// 参数对应相关文档：https://bytedance.feishu.cn/docs/doccnBxOCtFV68O0zZUA3OZWvZc
/** 生成对应openurl */
export default function createOpenUrl(params: {
  url: string;
  /** 是否需要native的titlebar [default: true] */
  useTitlebar?: boolean;
  /** 是否需要native的状态栏 [default: true] */
  useStatusBar?: boolean;
  /** 是否需要携带通参 [default: false] */
  useCommonParams?: boolean;
  /** 是否是活动页 [default: true]（后续会去掉，原因参照文档评论部分） */
  isActivity?: boolean;
  /** Titlebar 右边的icon类型 [default: more] */
  rightButton?: 'more' | 'share' | 'none';
  /** 禁用橡皮筋效果 */
  preventBounces?: boolean;
}) {
  const {
    url: originUrl,
    useTitlebar = true,
    useStatusBar = true,
    useCommonParams = false,
    isActivity = true,
    rightButton,
    preventBounces,
  } = params;
  let url = originUrl;
  let schemeParams = '';
  // android的webview参数是拼在url里，而iOS是拼在scheme里 (后续会做统一拼在schema中)

  if (!useTitlebar) {
    const concat = url.includes('?') ? '&' : '?';
    url = `${url}${concat}hide_navigation_bar=1`;
    schemeParams += '&hide_navigation_bar=1';
  }

  if (!useStatusBar) {
    schemeParams += '&allow_change_statusbar=1';
  }

  if (useCommonParams) {
    const concat = url.includes('?') ? '&' : '?';
    url = `${url}${concat}need_common_params=true`;
    schemeParams += '&append_common=1';
  }

  if (isActivity) {
    schemeParams += '&webview_type=campaign';
  }

  if (rightButton) {
    schemeParams += `&right_button_type=${rightButton}`;
  }

  if (preventBounces) {
    const concat = url.includes('?') ? '&' : '?';
    url = `${url}${concat}disable_bounces=1`;
    schemeParams += '&prevent_bounces=1';
  }

  const openUrl = `webview?url=${encodeURIComponent(url)}${schemeParams}`;

  return openUrl;
}
